/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Outputtokens1Inputs */

const zh_analytics_outputtokens1 = /** @type {(inputs: Analytics_Outputtokens1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输出 Tokens`)
};

const en_analytics_outputtokens1 = /** @type {(inputs: Analytics_Outputtokens1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output Tokens`)
};

const es_analytics_outputtokens1 = /** @type {(inputs: Analytics_Outputtokens1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokens de salida`)
};

/**
* | output |
* | --- |
* | "Output Tokens" |
*
* @param {Analytics_Outputtokens1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const analytics_outputtokens1 = /** @type {((inputs?: Analytics_Outputtokens1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Outputtokens1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_analytics_outputtokens1(inputs)
	if (locale === "en") return en_analytics_outputtokens1(inputs)
	return es_analytics_outputtokens1(inputs)
});
export { analytics_outputtokens1 as "analytics_outputTokens" }